import Icon from '../components/Icon.vue'

Icon.register({
  'grin-beam-sweat': {
    width: 504,
    height: 512,
    paths: [
      {
        d: 'M456 128c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0 13.1 17.4 41.6 57.8 41.6 77.8 0 26-21.5 47-48 47zM456 160c6.8 0 13.2-1.1 19.5-2.6 13.1 30.2 20.5 63.5 20.5 98.6 0 137-111 248-248 248s-248-111-248-248 111-248 248-248c50.3 0 97 15.1 136.1 40.8-7.8 18-8.1 27.8-8.1 32.2 0 43.6 35.9 79 80 79zM328 152c-23.8 0-52.7 29.3-55.8 71.4-0.7 8.5 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.5 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4zM168 152c-23.8 0-52.7 29.3-55.8 71.4-0.7 8.5 10.7 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.5 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4zM248 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.7-9.2-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.4-3.7-22.7 6.1-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-beam-sweat.js
// module id = 1403
// module chunks = 0